import { AxiosError } from 'axios';

export const errorInterceptor = (error: AxiosError) => {
    if (error.message === 'Network Error') {
        return Promise.reject(new Error('Erro de conexão.'));
    }

    if (error.response?.status === 401) {
        localStorage.clear();

        window.dispatchEvent(new Event('auth:unauthorized'));

        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }

        return Promise.reject(new Error('Sessão expirada. Faça login novamente.'));
    }

    return Promise.reject(error);
};